import { RADIO_TYPE, CHECKBOX_TYPE } from "Constants/FormElement";

export const FILTERS = [
    {
        id: 1,
        tabHeading: 'Status',
        contentJSON: [
            {
                label: 'Active',
                value: true
            }, {
                label: 'Deactive',
                value: false
            }
        ],
        type: RADIO_TYPE
    },
    {
        id: 2,
        tabHeading: 'Event',
        contentJSON: [
            {
                label: 'One time chef',
                value: false
            }, 
            {
                label: 'Chef for month',
                value: false
            }, 
            {
                label: 'Chef for party',
                value: false
            }, 
            {
                label: 'Mega event',
                value: false
            }, 
            {
                label: 'Monthly meal boxes',
                value: false
            }, 
            {
                label: 'From chef kitchen',
                value: false
            }
        ],
        type: CHECKBOX_TYPE
    },
    {
        id: 3,
        tabHeading: 'Chef',
        contentJSON: [
            {
                label: 'Assigned',
                value: true
            }, 
            {
                label: 'Not assigned',
                value: false
            }
        ],
        type: RADIO_TYPE
    },
    {
        id: 4,
        tabHeading: 'Status',
        contentJSON: [
            {
                label: 'Resolved',
                value: false
            }, 
            {
                label: 'Progress',
                value: false
            }, 
            {
                label: 'Close',
                value: false
            }, 
        ],
        type: CHECKBOX_TYPE
    },
]